<template>
  <div class="modal fade" ref="exampleModal" id="reject-modal" tabindex="-1" aria-labelledby="rejectModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered  modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ payload.titleModal }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="inputReason" class="form-label">{{ payload.formLabel }}</label>
            <textarea class="form-control" id="inputReason" rows="3" v-model="body.reason"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button
            id="modal-reject-dismiss"
            type="button"
            class="btn btn-outline-danger"
            :style="{flex: 1}"
            data-bs-dismiss="modal"
            >
            <strong class="text-uppercase">Cancel</strong>
          </button>
          <button
            type="button"
            class="btn btn-danger"
            :style="{flex: 1}"
            @click="onRejectClick()"
            >
            <strong class="text-white">{{ payload.textButton }}</strong>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    payload: {
      type: Object,
      default: () => ({
        titleModal: String,
        formLabel: String,
        textButton: String,
        actionPath: String,
        body: Object,
      })
    }
  },
  data() {
    return {
      titleModal: this.payload.titleModal,
      formLabel: this.payload.formLabel,
      textButton: this.payload.textButton,
      actionPath: this.payload.actionPath,
      body: this.payload.body,
    }
  },
  methods: {
    async onRejectClick() {
      document.getElementById("modal-reject-dismiss")?.click()
      await this.$store.dispatch(this.actionPath, this.body)

      this.$swal({
        icon: "success",
        title: "Success reject.",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        this.$router.go();
      });
    }
  }
}
</script>

<style scoped lang="scss">
</style>
